import { render, staticRenderFns } from "./editRole.vue?vue&type=template&id=87d7af46&scoped=true"
import script from "./editRole.vue?vue&type=script&lang=js"
export * from "./editRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d7af46",
  null
  
)

export default component.exports